import { request, type RequestOptions } from "@/utils/request";
import type { ShopAPI } from "@/api/typeings/shops";

/**
 * 获取店铺详情
 * @param params 店铺 {shopName: string}
 * @param options 请求配置
 */
export const getShopDetail = (params: any, options: RequestOptions = {}) => {
  return request("/api/shops/shopInfo", {
    method: "GET",
    params: { ...params },
    ...options,
  });
};

/**
 * 更新店铺信息
 * @param params 店铺信息
 * @param body
 * @param options 请求配置
 */
export async function shopUpdate(
  params: ShopAPI.ShopInfoParams,
  body: ShopAPI.ShopDto,
  options?: RequestOptions
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/api/shops/${param0}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      ...queryParams,
    },
    data: body,
    ...(options || { successMsg: "Update shop info successfully" }),
  });
}

export async function shopInfoById(id: string) {
  return request("/api/shops/shopInfoByShopifyId", {
    method: "GET",
    headers: {
      "shopify-id": id.split('.')[0],
    },
  });
}

export async function shopConfigById(id: string) {
  return request("/api/shopify/shops", {
    method: "GET",
    headers: {
      "shopify-id": id.split('.')[0],
    }
  });
}

export async function shopInstall(id: string, params: ShopAPI.ShopInstall) {
  const { ...queryParams } = params;
  return request<any>(`/api/shopify/app/install`, {
    method: "GET",
    headers: {
      "shopify-id": id,
    },
    params: {
      scope: queryParams.scope,
      shopId: id,
    },
  });
}

// 检查店铺是否安装
export async function checkShopInstall(id: string) {
  return request("/api/shopify/app/check-installed", {
    method: "GET",
    headers: {
      "shopify-id": id,
    },
  });
}

/**
 * 获取店铺与系统授权版本
 */
export async function getAuthVersion(options: RequestOptions = {}) {
  const res = (await request<ShopAPI.AuthVersionResponse>(
    "/api/shopify/app/getAuthVersion",
    {
      method: "GET",
      ...options,
    }
  )) as unknown as ShopAPI.AuthVersionResponse

  return res?.data
}

/**
 * 获取重新授权跳转链接
 */
export async function reauthorize(options: RequestOptions = {}) {
  const res = (await request<ShopAPI.ReauthorizeResponse>(
    "/api/shopify/app/reauthorize",
    {
      method: "GET",
      ...options,
    }
  )) as unknown as ShopAPI.ReauthorizeResponse

  return res?.data
}
